import type { RouteRecordRaw } from "vue-router"
import { useAuth } from "@/stores/auth"
import { clearLocalStorage } from "@/utils/localStorage"

const routes: RouteRecordRaw = {
  path: "/",
  name: "AuthForm",
  redirect: "Login",
  component: () => import("@/views/AuthView.vue"),
  children: [
    {
      path: "/login",
      name: "Login",
      component: () => import("@/templates/auth/components/AuthForm.vue"),
      beforeEnter: [checkAccessToken]
    },
    {
      path: "/logout",
      name: "Logout",
      component: () => import("@/templates/auth/components/AuthForm.vue"),
      beforeEnter: [logout]
    },
    {
      path: "/create-password",
      name: "CreatePassword",
      component: () => import("@/templates/auth/components/PasswordForm.vue"),
      beforeEnter: [hasTokenAsQueryParam]
    },
    {
      path: "/forgot-password",
      name: "ForgotPassword",
      component: () => import("@/templates/auth/components/PasswordForm.vue"),
      beforeEnter: [hasTokenAsQueryParam]
    },
    {
      path: "/send-email",
      name: "SendEmail",
      component: () =>
        import("@/templates/auth/components/ForgotPasswordForm.vue")
    }
  ]
}

function hasTokenAsQueryParam() {
  const urlParams = new URLSearchParams(window.location.search)
  const hasAccessToken = urlParams.has("token")
  if (!hasAccessToken) return { path: "Login" }
}

function logout() {
  const useAuthStore = useAuth()
  useAuthStore.logout()
}

function checkAccessToken() {
  if (localStorage.getItem("access_token")) return { name: "dashboard" }
  clearLocalStorage()
}

export default routes
